<template lang="pug">
main
  PmHeader
  transition(name="move")
    pm-notification(v-show = "showNotification")
      p(slot = "body")
        strong {{ mensaje }}

  transition(name="move")
    pm-loader(v-show = "isLoading")

  section.section(v-show = "!isLoading")
    nav.nav.has-shadow
    .container
      h1.title Notas de Crédito Electrónicas
      label.label
        abbr(title='Fecha ( aaaa-mm-dd )') Fecha Inicial
      input.input(
        type="text",
        placeholder="2009-01-29",
        v-model='fechaInicial',
        ref='fecha',
        @keyup.enter="buscar")
      label.label
        abbr(title='Fecha ( aaaa-mm-dd )') Fecha Final
      input.input(
        type="text",
        placeholder="2009-01-29",
        v-model='fechaFinal',
        @keyup.enter="buscar")
      .container
        p
          small {{ searchMessage }}
      .container
        .control
          label.radio
            input(type='radio', value='Todos', v-model='estado', @keyup.enter="buscar")
            label(for='Todos') Todos
            input(type='radio', value='NoAutorizados', v-model='estado', @keyup.enter="buscar")
            label(for='NoAutorizados') No Autorizados
            input(type='radio', value='Autorizados', v-model='estado', @keyup.enter="buscar")
            label(for='Autorizados') Autorizados
        //- .container.notification
        //-   .p {{ estado }}
      a.button.is-primary(@click="buscar") Buscar
      | {{ ' ' }}
      a.button.is-info(@click="autorizar") Autorizar
      | {{ ' ' }}
      a.button.is-success(@click="verificar") Verificar
      | {{ ' ' }}
      a.button.is-warning(@click="fechas") f
      | {{ ' ' }}
      a.button.is-danger(@click="limpiar") &times;
    .container
      pm-detalle(v-bind:tracks = "tracks")
</template>

<script>
import trackService from '@/services/track'

import PmHeader from '../components/layout/Header.vue'
import PmDetalle from './DetalleNotaCredito.vue'

import PmLoader from '@/components/shared/Loader.vue'
import PmNotification from '@/components/shared/Notification.vue'
import moment from 'moment'

export default {
  name: 'app',

  components: {
    PmDetalle,
    PmLoader,
    PmNotification,
    PmHeader
  },

  data () {
    return {
      fechaInicial: moment().format('YYYY-MM-DD'),
      fechaFinal: moment().format('YYYY-MM-DD'),
      estado: 'Todos',
      tracks: [],
      mensaje: 'No se encontraron resultados',

      isLoading: false,
      showNotification: false
    }
  },

  mounted () {
    if (localStorage.getItem('token')) {
      this.$refs.fecha.focus()
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  computed: {
    searchMessage () {
      return `Encontrados: ${this.tracks.length}`
    }
  },

  watch: {
    showNotification () {
      if (this.showNotification) {
        setTimeout(() => {
          this.showNotification = false
          this.mensaje = 'No se encontraron resultados'
        }, 3000)
      }
    }
  },

  methods: {
    buscar () {
      if (!this.fechaInicial || !this.fechaFinal) {
        console.log('No existe el rango de fechas')
        return
      }

      if (!this.validaFecha(this.fechaInicial) || !this.validaFecha(this.fechaFinal)) {
        console.log('Fechas no válidas')
        this.mensaje = 'Rango de fechas no válido'
        this.showNotification = true
        return
      }

      this.isLoading = true

      console.log('Buscando ... ')
      trackService.buscaNotaCredito(this.fechaInicial, this.fechaFinal, this.estado)
        .then(res => {
          this.showNotification = res.length === 0
          this.tracks = res
          this.isLoading = false
        })
    },
    buscarAfter (fechaInicio, fechaFin) {
      this.estado = 'Todos'
      trackService.buscaNotaCredito(fechaInicio, fechaFin, this.estado)
        .then(res => {
          this.tracks = res
        })
    },
    autorizar () {
      if (!this.fechaInicial || !this.fechaFinal) {
        console.log('No existe el rango de fechas')
        return
      }

      if (!this.validaFecha(this.fechaInicial) || !this.validaFecha(this.fechaFinal)) {
        this.mensaje = 'Rango de fechas no válido'
        this.showNotification = true
        return
      }

      this.tracks = []
      this.isLoading = true
      console.log('Autorizando ... ')
      trackService.autorizaNotaCredito(this.fechaInicial, this.fechaFinal)
        .then(res => {
          this.showNotification = res.length === 0
          this.buscarAfter(this.fechaInicial, this.fechaFinal)
          this.isLoading = false
        })
    },
    verificar () {
      if (!this.fechaInicial || !this.fechaFinal) {
        console.log('No existe el rango de fechas')
        return
      }

      if (!this.validaFecha(this.fechaInicial) || !this.validaFecha(this.fechaFinal)) {
        this.mensaje = 'Rango de fechas no válido'
        this.showNotification = true
        return
      }

      this.tracks = []
      this.isLoading = true
      console.log('Verificando ... ')
      trackService.verificaNotaCredito(this.fechaInicial, this.fechaFinal)
        .then(res => {
          this.showNotification = res.length === 0
          this.buscarAfter(this.fechaInicial, this.fechaFinal)
          this.isLoading = false
        })
    },
    validaFecha (fecha) {
      return moment(fecha, 'YYYY-MM-DD', true).isValid()
    },
    fechas () {
      this.$refs.fecha.focus()
      this.fechaInicial = moment().format('YYYY-MM-DD')
      this.fechaFinal = moment().format('YYYY-MM-DD')
    },
    limpiar () {
      this.$refs.fecha.focus()
      this.fechaInicial = ''
      this.fechaFinal = ''
      this.estado = 'Todos'
    }
  }
}
</script>

<style lang="scss">

</style>
